module.exports = __webpack_public_path__ + "static/DS-PIO2000-aae7a3b8609b0cdee49ec1f9b6186a8b.jpg";